import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { App } from '../../shared/containers/app/app';
import { IApplicationContext } from '../../shared/types/application';
import { IReduxStore } from '../../shared/types/redux';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;

  const projectName = context.config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(rootElement, <App reduxStore={store} context={context} />);
}
